import React from "react";
import ReactDOM from "react-dom";
import {
  PDFDownloadLink,
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font
} from "@react-pdf/renderer";
import { modalRoot } from "../../../utils/modal/modalDiv";

import "./menuPrintModal.css";

import roboto from "./roboto-medium-webfont.ttf";

Font.register({
  family: "Roboto",
  format: "truetype",
  src: roboto
});

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    backgroundColor: "white"
  },
  section: {
    margin: 7,
    padding: 7,
    flexGrow: 1
  },
  menuName: {
    fontFamily: "Roboto",
    textAlign: "center"
  },
  menuDate: {
    fontSize: "14pt"
  },
  dishItemCategory: {
    fontFamily: "Roboto",
    fontWeight: "bold",
    textAlign: "center",
    fontSize: "12pt",
    marginBottom: "1pt",
    marginTop: "1pt"
  },
  dishItemName: {
    fontSize: "12pt",
    fontWeight: "bold",
    display: "block",
    fontFamily: "Roboto",
    textAlign: "left",
    justifyContent: "flex-start",
    flexGrow: "3"
  },
  dishItemPrice: {
    fontSize: "12pt",
    fontWeight: "bold",
    display: "block",
    fontFamily: "Roboto"
  },
  dishItemServing: {
    display: "block",
    fontWeight: "bold",
    fontFamily: "Roboto",
    fontSize: "10pt",
    width: "3cm"
  }
});

const sortByCategory = (a, b) => {
  let A = a.dishBody.category;
  let B = b.dishBody.category;

  if (A > B) {
    if (A === "САЛАТЫ") return -1;
    if (
      A === "ГАРНИРЫ" &&
      B !== "САЛАТЫ" &&
      B !== "1-е БЛЮДА" &&
      B !== "2-е БЛЮДА"
    )
      return -1;
    return 1;
  } else if (B > A) {
    if (B === "САЛАТЫ") return 1;
    if (
      B === "ГАРНИРЫ" &&
      A !== "САЛАТЫ" &&
      A !== "1-е БЛЮДА" &&
      A !== "2-е БЛЮДА"
    )
      return 1;
    return -1;
  } else {
    return 0;
  }
};

const correctCategoryName = (dishCategory) => {
  let categoryName = "";
  if (dishCategory.toUpperCase() === "1-Е БЛЮДА") {
    categoryName = "СУПЫ";
  } else if (dishCategory.toUpperCase() === "2-Е БЛЮДА") {
    categoryName = "ГОРЯЧИЕ БЛЮДА";
  } else if (dishCategory.toUpperCase() === "САЛАТЫ") {
    categoryName = "САЛАТЫ И ХОЛОДНЫЕ ЗАКУСКИ";
  } else if (dishCategory.toUpperCase() === "РАЗНОЕ") {
    categoryName = "";
  } else {
    categoryName = dishCategory;
  }
  return categoryName;
};

const PDFDocument = ({ menu }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.section}>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginBottom: "1pt"
          }}
        >
          <Text style={styles.menuName}>{menu.name}</Text>
          <Text style={styles.menuDate}>
            {new Date(menu.menuDate).toLocaleDateString("en-US")}
          </Text>
        </View>
        {menu.dishes.sort(sortByCategory).map((dish, index, sortedArray) => {
          return (
            <React.Fragment key={dish.dishBody._id}>
              {(sortedArray[index - 1] &&
                sortedArray[index - 1].dishBody.category) ===
              dish.dishBody.category ? null : (
                <Text style={styles.dishItemCategory}>
                  {correctCategoryName(dish.dishBody.category)}
                </Text>
              )}
              <View
                style={{
                  borderBottom: "1pt solid black",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginBottom: "1pt"
                }}
              >
                <Text style={styles.dishItemServing}>
                  {dish.dishBody.serving} g
                </Text>
                <Text style={styles.dishItemName}>{dish.dishBody.name}</Text>
                <Text style={styles.dishItemPrice}>
                  {dish.dishBody.price} $
                </Text>
              </View>
            </React.Fragment>
          );
        })}
      </View>
    </Page>
  </Document>
);

class DownloadPDFModal extends React.Component {
  constructor(props) {
    super(props);

    this.ModalDiv = document.createElement("div");
  }

  componentDidMount() {
    modalRoot.appendChild(this.ModalDiv);
  }

  componentWillUnmount() {
    modalRoot.removeChild(this.ModalDiv);
  }

  render() {
    return ReactDOM.createPortal(
      <div className="downloadPDF_modal_div">
        <div
          className="downloadPDF_modal_container"
          onClick={this.props.handleShowDownloadPDFModal}
        >
          <PDFDownloadLink
            document={<PDFDocument menu={this.props.menu} />}
            fileName={this.props.menu.name}
          >
            {({ blob, url, loading, error }) =>
              loading ? "Document is created..." : "Download PDF"
            }
          </PDFDownloadLink>
        </div>
        <button
          className="downloadPDFModal_div__CloseBtn"
          onClick={this.props.handleShowDownloadPDFModal}
        >
          x
        </button>
      </div>,
      this.ModalDiv
    );
  }
}

export default DownloadPDFModal;
